import { Salesperson, SalespersonRequestInterface } from './interfaces/salesperson.interface';

export class SalespersonResponse implements Salesperson {
  partnerId: string;
  marketId: string;
  salespersonId: string;
  firstName: string;
  lastName: string;
  email: string;
  fullName: string;

  static fromProto(proto: any): SalespersonResponse {
    if (!proto) {
      return null;
    }
    const m = new SalespersonResponse();
    for (const key in proto) {
      if (Object.prototype.hasOwnProperty.call(proto, key)) {
        m[key] = proto[key];
      }
    }

    return m;
  }

  constructor(kwargs?: Salesperson) {
    if (!kwargs) {
      return;
    }
    for (const key in kwargs) {
      if (Object.prototype.hasOwnProperty.call(kwargs, key)) {
        this[key] = kwargs[key];
      }
    }
  }

  toApiJson(): object {
    if (
      typeof this.partnerId === 'undefined' &&
      typeof this.marketId === 'undefined' &&
      typeof this.salespersonId === 'undefined' &&
      typeof this.firstName === 'undefined' &&
      typeof this.lastName === 'undefined'
    ) {
      return null;
    }

    return {
      partnerId: typeof this.partnerId !== 'undefined' ? this.partnerId : null,
      marketId: typeof this.marketId !== 'undefined' ? this.marketId : null,
      salespersonId: typeof this.salespersonId !== 'undefined' ? this.salespersonId : null,
      firstName: typeof this.firstName !== 'undefined' ? this.firstName : null,
      lastName: typeof this.lastName !== 'undefined' ? this.lastName : null,
      email: typeof this.email !== 'undefined' ? this.email : null,
      fullName: typeof this.fullName !== 'undefined' ? this.fullName : null,
    };
  }
}

export class SalespersonRequest implements SalespersonRequestInterface {
  partnerId: string;
  marketIds: string[];
  includeNullMarket: boolean;

  static fromProto(proto: any): SalespersonRequest {
    if (!proto) {
      return null;
    }
    const m = new SalespersonRequest();
    for (const key in proto) {
      if (Object.prototype.hasOwnProperty.call(proto, key)) {
        m[key] = proto[key];
      }
    }
    return m;
  }

  constructor(kwargs?: SalespersonRequestInterface) {
    if (!kwargs) {
      return;
    }
    for (const key in kwargs) {
      if (Object.prototype.hasOwnProperty.call(kwargs, key)) {
        this[key] = kwargs[key];
      }
    }
  }

  toApiJson(): object {
    if (
      typeof this.partnerId === 'undefined' &&
      typeof this.marketIds === 'undefined' &&
      typeof this.includeNullMarket === 'undefined'
    ) {
      return null;
    }

    return {
      pid: typeof this.partnerId !== 'undefined' ? this.partnerId : null,
      marketId: typeof this.marketIds !== 'undefined' ? this.marketIds : null,
      includeNullMarketFlag: typeof this.includeNullMarket !== 'undefined' ? this.includeNullMarket : null,
    };
  }
}
